import LoggedInBoilerplate from "../LoggedInBoilerplate";
import NomenclatureOfVacation from "../nomenclature/NomenclatureOfVacation";

export default function VacationListPage() {
  return (
    <LoggedInBoilerplate titleLine1={"Liste de"} titleLine2={"conges"}>
      <NomenclatureOfVacation />
    </LoggedInBoilerplate>
  );
}
